import React, { ReactElement } from 'react';
import StatickyObsahRouter from './routing/StatickyObsahRouter';
import { ClientStatusContextProvider } from './context/ClientStatusContext';
import './main.scss';
import { SecurityContextProvider } from './context/SecurityContext';
import { SuccessMessageContextProvider } from './context/SuccessMessageContext';

const App = (): ReactElement => (
  <SuccessMessageContextProvider>
    <SecurityContextProvider>
      <ClientStatusContextProvider>
        <StatickyObsahRouter />
      </ClientStatusContextProvider>
    </SecurityContextProvider>
  </SuccessMessageContextProvider>
);

export default App;
